export function signupFormValidation(value: any) {

    const emailRegex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
    const passwordRegex = /^(?!.*\s)(?=.{6,})(?=.*[A-Z])(?=.*[0-9])(?=.*[@#$%^&+=]).*$/;
    const alpharegex = /^[A-Za-z ]+$/;
    let errors: any = {};

    const email = (value?.email || '').trim();
    const password = value?.password || '';
    const confirmPassword = value?.confirm_password || '';
    const username = (value?.username || '').trim();
    const countryDialCode = (value?.countryDialCode !== undefined && value?.countryDialCode !== null) ? value.countryDialCode.toString().trim() : '';
    const mobile = (value?.mobile !== undefined && value?.mobile !== null) ? value.mobile.toString().trim() : '';
    const country = value?.country;
    const state = value?.state;

    if (email === '') {
        errors['email'] = 'Email address is required';
    } else if (!emailRegex.test(email)) {
        errors['email'] = 'Enter a valid email address';
    }

    if (password === '') {
        errors['password'] = 'Password is required';
    } else if (!passwordRegex.test(password)) {
        errors['password'] = 'Enter a valid password';
    }

    if (confirmPassword === '') {
        errors['confirm_password'] = 'Password is required';
    } else if (!passwordRegex.test(confirmPassword)) {
        errors['confirm_password'] = 'Enter a valid password';
    } else if (password !== confirmPassword) {
        errors['confirm_password'] = 'Passwords do not match';
    }
    
    if (username === '' || !alpharegex.test(username)) {
        errors['username'] = 'Enter a valid name';
    }
    
    if (countryDialCode === '') {
        errors['countryDialCode'] = 'Country code is required';
    }
    
    if (mobile === '') {
        errors['mobile'] = 'Phone number is required';
    } 

    if (country === 0 || country === '0' || country === '' || country === undefined || country === null) {
        errors['country'] = 'Country is required';
    }
    if (state === 0 || state === '0' || state === '' || state === undefined || state === null) {
        errors['state'] = 'State is required';
    }

    return errors;
}

